import { Typography, Button, Grid, } from '@material-ui/core'
import React, { ChangeEvent, Dispatch, ReactNode } from 'react'
import { OrganizationsClient, UserWithOrganizationResponseDTO, SubGroupsClient } from '../generated/ApiClient'
import { Formik, Form } from 'formik'
import { useDispatch } from "react-redux";
import { actionCreators as snackbar } from '../store/AlertSnackbarStore'
import ValuePickerControl from '../common/ValuePickerControl'
import { RouteComponentProps } from 'react-router'

async function formSubmitCallback(subgroupId: string | undefined, userId: string, dispatch: Dispatch<any>) {
    try {
        if (subgroupId && userId) {
            const result = await new SubGroupsClient().addUser2(subgroupId, userId);
            dispatch(snackbar.addMessage({ title: "Success", message: `Member successfully added`, alertType: 'success' }))
        }
    }
    catch (error) {
        dispatch(snackbar.addError(error, undefined, 'Error writing to the database'));
    }
}

export default function AddMemberForm(props: RouteComponentProps<{ subgroupId: string, organizationId: string }>) {
    const dispatch = useDispatch();
    const organizationId = props.match.params.organizationId;

    const [selectedUserId, setSelectedUserId] = React.useState('0');
    const [orgUsers, setOrgUsers] = React.useState<UserWithOrganizationResponseDTO[]>([]);

    React.useEffect(() => {
        const fetchData = async () => {
            const usersData = await new OrganizationsClient().getManyUsersAll(organizationId);

            if (usersData.length > 0) {
                setOrgUsers(usersData);
                setSelectedUserId(usersData[0]?.azureId)
            }
        }
        fetchData();
    }, [organizationId, props.match.params.subgroupId]);

    const users = orgUsers.map(x => {
        return { text: x.displayName ?? '', value: x.azureId }
    })

    const handleUserSelectedChange = (event: ChangeEvent<{ name?: string | undefined; value: unknown; }>, child: ReactNode) => {
        let target = event.target as HTMLInputElement;
        setSelectedUserId(target.value)
    };
    return (
        <Grid container direction='column' spacing={1} >
            <Grid item >
                <Typography paragraph display='inline'><b>Members:</b>&nbsp;</Typography>
            </Grid>
            <Grid item>
                <ValuePickerControl items={users} handleChange={handleUserSelectedChange}></ValuePickerControl>
            </Grid>
            <Grid item>
                <Button style={{ marginTop: 20 }} variant='contained' color='primary' size='medium' onClick={() => formSubmitCallback(props.match.params.subgroupId, selectedUserId, dispatch)}>Add</Button>
            </Grid>
        </Grid>
    )
}